const style = {
  row: {
    border: `1px solid transparent`,
    borderBottom: `1px solid #666`,
    ':hover': {
      border: `1px solid #666`,
      background: `#fbfbfb`
    }
  },
  rowActive: {
    border: `1px solid #666`,
    background: `#fbfbfb`
  },
  permRow: {
    borderColor: `#666`
    // background: `#f4f4f4`,
  },
  permRowActive: {
    borderTop: `1px solid #666`
  },
  header: {
    borderBottom: `1px solid #666`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/partials/GroupTable/style/ColorBlind/list.js